// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n/* show underline on links inside tables */\ntr:hover .emd-link {\n  text-decoration: underline;\n}\n._decoration_underline {\n  text-decoration: underline;\n}\n@media (min-width: 1920px) {\n.el-main__content.el-main__content_xl {\n    max-width: 1920px;\n    margin: 0 auto;\n}\n}\n", ""]);
// Exports
module.exports = exports;
